import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule }   from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { MenuCompoment } from './navegacao/menu/menu.component';
import { HomeComponent } from './paginas/home/home.component';
import { GerenciarRelatoriosComponent } from './paginas/relatorios/gerenciar-relatorios/gerenciar-relatorios.component';
import { ConsultarDadosComponent } from './paginas/consultar-dados/consultar-dados.component';
import { GerenciarGruposComponent } from './paginas/administracao/gerenciar-grupos/gerenciar-grupos.component';
import { PermissionService } from './shared/services/permission.service';
import { TopBarComponent } from './navegacao/top-bar/top-bar.component';
import { GerenciarUsuariosComponent } from './paginas/administracao/gerenciar-usuarios/gerenciar-usuarios.component';
import { AppRoutingModule }     from './app-routing/app-routing.module';
import { EditDelRelatoriosComponent } from './paginas/relatorios/edit-del-relatorios/edit-del-relatorios.component';
import { ReportsService } from "./shared/services/reports.service";
import { StringFilterPipe } from "./shared/classes/StringFilterPipe";
import { ConsultaService } from "./shared/services/consulta.service";

import { Adal4Service, Adal4HTTPService } from 'adal-angular4';   
import { SelectedReportPipe } from "./shared/classes/SelectedReportPipe";
import { TokenService } from "./shared/services/token.service";
import { GerenciarConexoesComponent } from './paginas/relatorios/gerenciar-conexoes/gerenciar-conexoes.component';
import { AuditoriaComponent } from './paginas/administracao/auditoria/auditoria.component';


@NgModule({
  declarations: [
    AppComponent,
    MenuCompoment,
    HomeComponent,
    GerenciarRelatoriosComponent,
    ConsultarDadosComponent,
    GerenciarGruposComponent,
    TopBarComponent,
    GerenciarUsuariosComponent,
    EditDelRelatoriosComponent,
    StringFilterPipe,
    SelectedReportPipe,    
    GerenciarConexoesComponent, AuditoriaComponent    
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    NgxPaginationModule 
    // RouterModule.forRoot([
    //   {
    //     path: 'home',
    //     component: HomeComponent
    //   }
    // ])
  ],
  providers: [
    PermissionService, 
    ReportsService, 
    ConsultaService,
    TokenService,
    Adal4Service,                                                      
    {                                                                   
      provide: Adal4HTTPService,                                      
      useFactory: Adal4HTTPService.factory,                             
      deps: [Http, Adal4Service]                                       
    }],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/app.module.ts